'use client';

/**
 * SysObeyaKpiAvgCcCard — Complexity Hotspots KPI tile.
 *
 * Slices `response.totals.avg_cc` from the system_obeya_view
 * high_cc_functions call. Hero number is the average cyclomatic
 * complexity across all flagged functions.
 *
 * @see klyde_edge/ui_config/composition/cards/system_obeya.py — content_key="sys_obeya_kpi_avg_cc"
 * @see klyde_edge/ui_config/labels/system_obeya.py — high_cc_kpi_avg_cc_*
 */

import { TrendingUp } from 'lucide-react';
import { useSystemObeyaView } from './use-system-obeya-view';
import { KpiTile, fmt } from './kpi-tile';

interface Props {
  view_name?: string;
}

export function SysObeyaKpiAvgCcCard({ view_name = 'high_cc_functions' }: Props) {
  const { data, isLoading, queryKey } = useSystemObeyaView(view_name);
  const L = data?.labels ?? {};
  const t = data?.totals ?? {};
  return (
    <KpiTile
      contentKey="sys_obeya_kpi_avg_cc"
      label={L.high_cc_kpi_avg_cc_label ?? ''}
      Icon={TrendingUp}
      value={isLoading ? '…' : fmt(t.avg_cc)}
      queryKey={queryKey}
    />
  );
}
